import { render, staticRenderFns } from "./Gouvernance.vue?vue&type=template&id=096a4d97"
import script from "./Gouvernance.vue?vue&type=script&lang=js"
export * from "./Gouvernance.vue?vue&type=script&lang=js"
import style0 from "./Gouvernance.vue?vue&type=style&index=0&id=096a4d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports